import clsx from 'clsx';
import { Component } from '@headless-workspace/typings';
import { GlowIcon, GlowTextCaption, Icons, PropsWithClassName } from '../../../../src';

type GlowErrorProps = PropsWithClassName & {
    text?: string;
};

export const GlowError: Component<GlowErrorProps> = ({ text, className }) => {
    return (
        <div
            className={clsx('flex gap-0.25 items-center fill-text-error', !text && 'invisible line-clamp-1', className)}
        >
            <GlowIcon Icon={Icons.Warning} type={'small'} />
            {text && <GlowTextCaption text={text} color={'error'} />}
        </div>
    );
};
